import { environment } from "../environment";
import { Login, JWTInfo } from "../models/auth";
import { AsyncResult } from "../models/common/async-result";
import { useUserStore } from "../store/useUser";
import api from './api';

export async function performLogin(payload: Login): Promise<AsyncResult<JWTInfo>> {
    payload.grant_type = 'password'
    
    const response = await api.post<AsyncResult<JWTInfo>>(environment.api.auth.login,
        payload, {
        headers: {
            "Content-Type": "application/json"
        }
    })
        .then(resp => { return { success: resp.data.success, error: void 0 } })
        .catch((err) => { return { success: void 0, error: err.response.data.error } });

    if (response.error) return { error: response.error }

    return { success: response.success };
}

export async function refreshToken(): Promise<AsyncResult<JWTInfo>> {
    const refresh_token = useUserStore.getState()?.jwt?.refresh_token

    const payload = {
        'grant_type': 'refresh_token',
        'refresh_token': refresh_token
    }

    const response = await api.post(environment.api.auth.refresh_token, payload)
        .then<{ success: JWTInfo, error:void }>(resp => { return { success: resp?.data.success, error: void 0 } })
        .catch<{ success: void, error: string }>((err) => { return { success: void 0, error: err.response?.data.error } });

    if (response.error) return { error: response.error }

    if(response.success){
        useUserStore.getState().setJwt(response?.success)

        return { success: response.success };
    }
}